import script from "./MenuNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuNavigation.vue?vue&type=script&setup=true&lang=js"

import "./MenuNavigation.vue?vue&type=style&index=0&id=486c2286&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-486c2286"]])

export default __exports__